import { Uprawnienie } from "../wspolne/uprawnienie";
import { DaneKlientaProfil } from "./daneKlientaProfil";

export class PobierzDaneKontaRezultat {
    public imie: string;
    public nazwisko: string;
    public email: string;
    public numerTelefonu: string;
    public rola: Uprawnienie;
}